// extracted by mini-css-extract-plugin
module.exports = {"content":"_1mlSt","title":"_3lDhk","dec":"pehy5","btn":"oaumn"};